/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Tokens_Generated_BadgeInputs */



/**
* | output |
* | --- |
* | "Total tokens generated" |
*
* @param {Dashboard_Tokens_Generated_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_tokens_generated_badge = /** @type {((inputs?: Dashboard_Tokens_Generated_BadgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Tokens_Generated_BadgeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Insgesamt generierte Tokens")
	return /** @type {LocalizedString} */ ("Total tokens generated")
});